import React, { createContext, useContext, useState, useCallback } from 'react'
import ConfirmDialog from '../Components/Dialogs/ConfirmDialog'
import { appDownloadNudgeDismissed, redirectSmart } from '../Global/Functions'
import AppDownloadNudgeDialog from '../Components/AppDownloadNudgeCard/AppDownloadNudgeDialog'

const GetAppDialogContext = createContext(null)

export const GetAppDialogProvider = ({ children }) => {
  const [dialogState, setDialogState] = useState({
    open: false,
    allowDismiss: true,
  })

  const show = useCallback(() => {
    setDialogState({
      open: true,
      allowDismiss: true,
    })
  }, [])

  const showSticky = useCallback(() => {
    setDialogState({
      open: true,
      allowDismiss: false,
    })
  }, [])

  const close = useCallback(() => {
    setDialogState((prev) => ({ ...prev, open: false }))
  }, [])

  return (
    <GetAppDialogContext.Provider value={{ show, showSticky, close }}>
      {children}
      <AppDownloadNudgeDialog
        isSticky={!dialogState.allowDismiss}
        open={dialogState.open}
        onClose={() => {
          appDownloadNudgeDismissed()
          setDialogState((prev) => ({ ...prev, open: false }))
        }}
        onOpenApp={() => {
          appDownloadNudgeDismissed()
          redirectSmart() // your deep-link logic
        }}
        onContinueWeb={() => {
          appDownloadNudgeDismissed()
          setDialogState((prev) => ({ ...prev, open: false }))
        }}
      />
    </GetAppDialogContext.Provider>
  )
}

export const getAppNudge = () => useContext(GetAppDialogContext)
